import { cn } from "@/lib/utils";

interface ProgressIndicatorProps {
	currentStep: number;
	totalSteps: number;
	onStepClick?: (step: number) => void;
}

export function ProgressIndicator({
	currentStep,
	totalSteps,
	onStepClick,
}: ProgressIndicatorProps) {
	const steps = Array.from({ length: totalSteps }, (_, i) => ({ id: i }));

	return (
		<div className="flex items-center justify-center gap-2">
			{steps.map(({ id }) => {
				const isActive = id === currentStep;
				const isPast = id < currentStep;
				const isLast = id === totalSteps - 1;

				return (
					<div key={id} className="flex items-center">
						{/* Step indicator */}
						<button
							type="button"
							onClick={() => onStepClick?.(id)}
							className={cn(
								"flex size-8 items-center justify-center rounded-full text-sm font-medium transition-all",
								"hover:scale-110 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:ring-offset-2",
								isActive &&
									"bg-primary text-primary-foreground ring-2 ring-primary/20 ring-offset-2",
								isPast && "bg-primary/80 text-primary-foreground hover:bg-primary/90",
								!isActive && !isPast && "bg-muted text-muted-foreground hover:bg-muted/80"
							)}
						>
							{id + 1}
						</button>

						{/* Connector line */}
						{!isLast && (
							<div
								className={cn(
									"h-[2px] w-8 transition-colors",
									isPast ? "bg-primary/60" : "bg-muted"
								)}
							/>
						)}
					</div>
				);
			})}
		</div>
	);
}
